export default [
  {
    path: '/manage-users',
    name: 'manage-users',
    component: () => import('@/views/manageUsers/ManageUsers.vue'),
    meta: {
      protected: true,
      requiresUserManager: true,
      pageTitle: 'Manage Users',
    },
  },
]
